/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Kind_LabelInputs */

const cs_templates_kind_label = /** @type {(inputs: Templates_Kind_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druh šablony`)
};

const en_templates_kind_label = /** @type {(inputs: Templates_Kind_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template kind`)
};

/**
* | output |
* | --- |
* | "Template kind" |
*
* @param {Templates_Kind_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_kind_label = /** @type {((inputs?: Templates_Kind_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Kind_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_kind_label(inputs)
	return cs_templates_kind_label(inputs)
});